import { render, staticRenderFns } from "./cancelProject.vue?vue&type=template&id=5b70f40a"
import script from "./cancelProject.vue?vue&type=script&lang=js"
export * from "./cancelProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports